export enum SurfaceTypesEnum {
    Festett = 0,
    Horganyzott = 1
}